/* eslint-disable max-lines */
import React, { useContext } from 'react'
import { LazyLoad } from '@usap/uicomponents'
import { LocalContext } from '../helpers/useLocalContext'
import { LoadableRecentlyViewedCardWmo } from './Loadables/RecentlyViewCard.loadable'
import isBrowser from './CheckoutV2/utility/isBrowser'
import getInventoryDetails from '../helpers/getInventoryDetails'
import { SeData, ProductDetails } from './RecentlyViewedWmo.types'
import {
  StyledCarouselContainer,
  StyledRecentlyViewedWidgetContainer,
  StyledContainer,
  StyledBox,
  StyledProductsContainer,
  StyledHeaderText,
  DesktopContainer,
} from './RecentlyViewedWmo.css'

const MOBILE_BREAKPOINT = '768px'

type RecentlyViewedWmoProps = {
  recentlyViewedItems: ProductDetails[]
  shippingExp: SeData | {}
}

const RecentlyViewedWmo = ({
  recentlyViewedItems,
  shippingExp,
}: RecentlyViewedWmoProps) => {
  const { isBot } = useContext(LocalContext)

  const isMobile =
    isBrowser() && window.innerWidth < parseInt(MOBILE_BREAKPOINT, 10)

  const recentlyViewedList = recentlyViewedItems.length > 0 && (
    <>
      <StyledHeaderText height="30px">Recently Viewed</StyledHeaderText>
      <StyledProductsContainer>
        {recentlyViewedItems.map((record, index) => (
          <LoadableRecentlyViewedCardWmo
            data={record}
            getInventoryDetails={getInventoryDetails}
            key={record.id}
            index={index}
            shippingExp={shippingExp}
          />
        ))}
      </StyledProductsContainer>
    </>
  )

  return (
    <LazyLoad once height={400} offset={100} isBot={isBot}>
      {isMobile ? (
        <StyledCarouselContainer>
          <StyledRecentlyViewedWidgetContainer gap="16px">
            {recentlyViewedList}
          </StyledRecentlyViewedWidgetContainer>
        </StyledCarouselContainer>
      ) : (
        <DesktopContainer>
          <StyledRecentlyViewedWidgetContainer gap="16px">
            <StyledContainer>
              <StyledBox>{recentlyViewedList}</StyledBox>
            </StyledContainer>
          </StyledRecentlyViewedWidgetContainer>
        </DesktopContainer>
      )}
    </LazyLoad>
  )
}

export default RecentlyViewedWmo
